import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CoinsCrypto({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M9.68 4.94201C12.26 2.35201 16.468 2.35201 19.058 4.94201C21.648 7.52201 21.648 11.73 19.058 14.32M7.7 14.35V11.55H10.522C11.292 11.55 11.912 12.17 11.912 12.94C11.912 13.71 11.282 14.33 10.512 14.33M9.47 10.751V11.551M9.47 17.98V17.07M16.264 14.368C16.264 18.028 13.294 21 9.632 21C5.962 21 3 18.03 3 14.368C3 10.698 5.96 7.73601 9.632 7.73601C13.292 7.73501 16.264 10.696 16.264 14.368ZM10.87 17.067H7.7V14.347H10.865C11.605 14.347 12.215 14.947 12.215 15.697C12.215 16.437 11.605 17.047 10.855 17.047L10.87 17.067Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CoinsCrypto;